import { List } from 'immutable'

export default List([
  'amount',
  'qty',
  'receipt_count',
  'customer_count',
  'amount_per_qty',
  'qty_per_receipt',
  'amount_per_receipt',
  'receipt_per_customer',
  'qty_per_customer',
  'amount_per_customer',
  'total_amount',
  'total_qty',
  'total_receipt_count',
])
